import {
    ActionStatus, IAction, IAsyncState, withAsyncStatus,
  } from "@webiz/redux-common";
  import {
    authenticateActions, getUserActions, logOutActions,
  } from "./AuthActions";
  
  export interface ISAuth {
    auth: IAsyncState;
  }
  
  const initialAsyncState = {
    status: ActionStatus.INITIAL,
    data: null,
    errors: null,
  };
  
  const initialState = {
    ...initialAsyncState,
  };
  
  export function AuthReducer(state = initialState, action: IAction) {
    switch (action.type) {
      case authenticateActions.REQUEST:
      case authenticateActions.SUCCESS:
      case authenticateActions.FAIL:
        return {
          ...state,
          ...withAsyncStatus(
            state, action, authenticateActions,
          ),
        };
      case logOutActions.REQUEST:
      case logOutActions.SUCCESS:
      case logOutActions.FAIL:
        return {
          ...state,
          ...withAsyncStatus(
            state, action, logOutActions,
          ),
        };
      case getUserActions.REQUEST:
      case getUserActions.SUCCESS:
      case getUserActions.FAIL:
        return {
          ...state,
          ...withAsyncStatus(
            state, action, getUserActions,
          ),
        };
      default:
        return state;
    }
  }
  